import { FC, useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $getSelection, $isRangeSelection, $isParagraphNode, TextNode } from 'lexical';
import { INSERT_ORDERED_LIST_COMMAND, INSERT_UNORDERED_LIST_COMMAND } from '@lexical/list';

const UL_TRIGGER = /^-\s$/;
const OL_TRIGGER = /^1\.\s$/;

export const AutoListPlugin: FC = () => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    return editor.registerNodeTransform(TextNode, (textNode) => {
      const parent = textNode.getParent();
      if (!$isParagraphNode(parent)) {
        return;
      }

      // Only the first text node in the paragraph can trigger this
      if (parent.getFirstChild() !== textNode) {
        return;
      }

      const selection = $getSelection();
      if (!$isRangeSelection(selection) || !selection.isCollapsed()) {
        return;
      }

      const anchor = selection.anchor;
      if (anchor.getNode().getKey() !== textNode.getKey()) {
        return;
      }

      const textBeforeCursor = textNode.getTextContent().slice(0, anchor.offset);

      let command = null;
      if (UL_TRIGGER.test(textBeforeCursor)) {
        command = INSERT_UNORDERED_LIST_COMMAND;
      } else if (OL_TRIGGER.test(textBeforeCursor)) {
        command = INSERT_ORDERED_LIST_COMMAND;
      }

      if (!command) {
        return;
      }

      // Strip the trigger text ("- " or "1. ")
      const remaining = textNode.getTextContent().slice(textBeforeCursor.length);
      textNode.setTextContent(remaining);

      // Put the cursor back at the start of the remaining text
      selection.anchor.set(textNode.getKey(), 0, 'text');
      selection.focus.set(textNode.getKey(), 0, 'text');

      // Convert the current block into the appropriate list
      editor.dispatchCommand(command, undefined);
    });
  }, [editor]);

  return null;
};
